import gql from 'graphql-tag';

export const REDEEM_APP_PROMO_CODE = gql`
  mutation app_redeemPromoCode($code: String!, $appId: ID) {
    app_redeemPromoCode(code: $code, appId: $appId) {
      offerDescription
    }
  }
`;

export const GET_DIET_TRACKING_WEB_SUBSCRIPTION_TRANSACTION_ID = gql`
  query app_getDietTrackingWebSubscriptionOriginalTransactionId {
    app_getDietTrackingWebSubscriptionOriginalTransactionId
  }
`;
